module.exports = __webpack_public_path__ + "img/charge-7.6a73d788.png";